import { ActiveFutureUpdateStatus, SubscriptionType } from '@stigg-common/types';

export function hasFutureUpdates(subscription: SubscriptionType, status: ActiveFutureUpdateStatus) {
  return subscription.futureUpdates.some(({ scheduleStatus }) => scheduleStatus === status);
}
